import { render, staticRenderFns } from "./tabSetupPayPal.vue?vue&type=template&id=60ccc5be&"
import script from "./tabSetupPayPal.vue?vue&type=script&lang=js&"
export * from "./tabSetupPayPal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports